//Telas
import TAprovacoes_list from "../aprovacoes/aprovacoes_list";

function TSolicitacao_det_aba_aprov({ solicitacao }) {
  return (
    <div className="m-1">
      <TAprovacoes_list aprovacoes={solicitacao.aprovacoes} />
    </div>
  );
}

export default TSolicitacao_det_aba_aprov;
